import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-screen-2xl mx-auto px-4 md:px-10" }
const _hoisted_2 = { class: "bg-white rounded-xl px-8 md:px-16 py-12 font-light" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailCutContent from "@/components/diamonds/details/DiamondDetailCutContent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondDetailCut',
  props: {
    cut: {},
    stoneType: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const getNormalizedCut = (c: string) => {
  if (!c) return "ex";
  c = c.toLowerCase();
  if (c === "id" || c === "ideal") return "id";
  if (c === "ex" || c === "excellent") return "ex";
  if (c === "vg" || c === "very good") return "vg";
  if (c === "gd" || c === "good") return "gd";
  return c;
};

const cuts = [
  { key: "gd", label: "Good" },
  { key: "vg", label: "Very Good" },
  { key: "ex", label: "Excellent" },
  { key: "id", label: "Ideal" },
];

const initialCutLabel = computed(() => {
  const cutValue = Array.isArray(props.cut) ? props.cut[0] : props.cut;
  const normalized = getNormalizedCut(cutValue);
  const found = cuts.find((c) => c.key === normalized);
  return found ? found.label : cutValue;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DiamondDetailCutContent, {
        cut: __props.cut,
        "stone-type": __props.stoneType
      }, {
        title: _withCtx(() => [
          _createVNode(BaseHeadline, { class: "!text-2xl mb-6 !normal-case !tracking-normal" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("components.diamonds.details.cut.title")) + ": " + _toDisplayString(initialCutLabel.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["cut", "stone-type"])
    ])
  ]))
}
}

})